import { render } from "./DisclaimerFooter.vue?vue&type=template&id=a9a3db64&scoped=true"
import script from "./DisclaimerFooter.vue?vue&type=script&lang=js"
export * from "./DisclaimerFooter.vue?vue&type=script&lang=js"

import "./DisclaimerFooter.vue?vue&type=style&index=0&id=a9a3db64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a3db64"]])

export default __exports__